import script from "./DebugLogPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DebugLogPage.vue?vue&type=script&setup=true&lang=ts"

import "./DebugLogPage.vue?vue&type=style&index=0&id=217d78b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-217d78b6"]])

export default __exports__